export type OrderFooterMessages = {
  talk2buy: string;

  orderGeneratedBy: string;
};

export const ORDER_FOOTER_MESSAGES: OrderFooterMessages = {
  talk2buy: "Talk2Buy",

  orderGeneratedBy: "Pedido gerado por",
};
